import { CalculationObject,Calculation } from "@helpers/interfaces/calculation";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface calculationState{
    value:Calculation
}

const initialState: calculationState = {
    value: {
      calculationResponses: [],
      recommendedPlan:{
        providerId:"1",
        withGST: 0,
        withoutGST: 0,
        withGSTRounded:0
      }
    }
}

export const calculationSlice = createSlice({
  name: "calculation",
  initialState,
  reducers: {
    setCalculationResponses: (state:calculationState, action:PayloadAction<CalculationObject[]>) => {
      state.value.calculationResponses = action.payload
    },
    setRecommendedPlan: (state:calculationState, action:PayloadAction<CalculationObject>) => {
      state.value.recommendedPlan = action.payload
    },
  },
});

export const {setRecommendedPlan, setCalculationResponses } = calculationSlice.actions;

export default calculationSlice.reducer;
